var description_default = {
  "subtitle": "-unjy",
  "descriptionItem": "_4FaLP"
};
export {
  description_default as default
};
//# sourceMappingURL=description-scss.js.map
